import { CSSTransition, TransitionGroup } from "react-transition-group";
import TopBanner from "./topBanner";
import "./layout.css";
import SideBar from "./sidebar";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import {
  authTokenSelector,
  sessionSelector,
} from "../store/selectors/auth.selector";
import { useCallback, useEffect } from "react";
import Footer from "./footer";
import { setLogout } from "../store/actions/app.action";
import { TimeoutLogic } from "../components/session-time-out/timeout-logic";
import FEATURE_CONFIG from "client/feature.config.json";
import AuthService from "../services/auth.service";
import { getErrorMessageSelector } from "../store/selectors/error.selector";

export default function Layout({ children }) {
  const authToken = useSelector(authTokenSelector);
  const navigate = useNavigate();
  const sessionLogout = useSelector(sessionSelector);
  const dispatch = useDispatch();
  const errors = useSelector(getErrorMessageSelector);

  useEffect(() => {
    if (authToken === null || authToken === undefined) {
      if (errors && ["ERR_NETWORK", "Network Error"].indexOf(errors["data"].code) > -1) {
        navigate("/");
      } else {
        generateServerKey();
      }
    }
  }, [authToken, errors]);

  // useEffect(() => {
  //   if (sessionLogout === true) {
  //     dispatch(setLogout(false));
  //     dispatch({ type: "USER_LOGOUT" });
  //     // generateServerKey();
  //   }
  // }, [sessionLogout]);

  const generateServerKey = useCallback(async () => {
    try {
      await AuthService.generateKey();
      // dispatch({ type: "RESET_ALL_STATE" });
      navigate("/");
    } catch (error) {}
  }, []);

  return (
    <>
      {/* <div className="top-banner">
        <TopBanner />
      </div> */}
      <div className="main-section">
        <div className="left-section">
          <SideBar />
        </div>
        <div className="right-section">
          <div className="top-banner">
            <TopBanner />
          </div>
          <div className="right-section-wrapper">
            <TransitionGroup>
              <CSSTransition classNames="my-node" timeout={300}>
                {children}
              </CSSTransition>
            </TransitionGroup>
          </div>
          <TimeoutLogic />{" "}
          {/* {FEATURE_CONFIG.DASHBOARD.FOOTER_TEXT && (
            <div className="mt-5">
              <Footer />
            </div>
          )} */}
        </div>
      </div>
    </>
  );
}
